import React from "react";
import { RoutesProvider } from "../Context/RoutesContext";
import RoutesContent from "./Routes/RoutesContent";

const Routes = () => {
  return (
    <RoutesProvider>
      <RoutesContent />
    </RoutesProvider>
  );
};

export default Routes;
